import React from 'react';
import { merchantProfile, sampleTransaction } from '../../data/gtbankUatData';
import { UatPageShell } from './UatDocumentationPage';

export default function EmailConfirmationPreviewPage() {
  return (
    <UatPageShell
      title="Email Confirmation Preview"
      breadcrumb="Email Confirmation"
      heading="Email Confirmation Preview"
      subtitle="Successful payment email preview for UAT documentation"
    >
      <p className="cs-m0" style={{ marginBottom: 24 }}>
        <strong>Subject:</strong> Payment Confirmation - {merchantProfile.name}
      </p>
      <div
        style={{
          padding: 26,
          borderRadius: 14,
          border: '1px solid rgba(255,255,255,0.08)',
          background: '#fff',
          color: '#111',
          lineHeight: 1.85,
        }}
      >
        <p>Dear {sampleTransaction.customerName},</p>
        <p>Your payment has been completed successfully.</p>
        <p>
          <strong>Transaction Details:</strong>
        </p>
        <p>Reference Number: {sampleTransaction.referenceNumber}</p>
        <p>Payment Reference: {sampleTransaction.paymentReference}</p>
        <p>Gateway Transaction ID: {sampleTransaction.gatewayTransactionId}</p>
        <p>Amount: {sampleTransaction.currency} {sampleTransaction.amount}</p>
        <p>Date: {sampleTransaction.dateLong}</p>
        <p>Thank you,</p>
        <p>{merchantProfile.name}</p>
      </div>
    </UatPageShell>
  );
}
